import React, { useEffect, useState } from "react";
import { ArrowLeft, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../assets/img/NewsImgs/logo192.png";
import { useLanguage } from "../../../i18n/LanguageContext";
import "./Navbar2.css";

const links = {
  fa: [["/", "خانه"], ["/jobs", "فرصت‌های شغلی"], ["/archive/all", "مجله و راهنماها"], ["/about-us", "درباره ما"], ["/contact-us", "تماس با ما"]],
  en: [["/", "Home"], ["/jobs", "Jobs"], ["/archive/all", "Resources"], ["/about-us", "About"], ["/contact-us", "Contact"]],
};

const Navbar2 = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { language, isEnglish, direction, toggleLanguage } = useLanguage();
  const copy = isEnglish ? { brand: "Infinity Apply", tagline: "Study, Work, Future", login: "Sign in", start: "Get started", open: "Open menu", close: "Close menu" } : { brand: "اینفینیتی اپلای", tagline: "تحصیل، کار، آینده", login: "ورود", start: "شروع مسیر", open: "باز کردن منو", close: "بستن منو" };
  useEffect(() => setOpen(false), [location.pathname]);

  return <header className="ia-nav" dir={direction}><div className="ia-nav__inner">
    <Link className="ia-nav__brand" to="/" aria-label={copy.brand}><img src={Logo} alt={copy.brand} /><div><strong>{copy.brand}</strong><small>{copy.tagline}</small></div></Link>
    <nav className={`ia-nav__links ${open ? "ia-nav__links--open" : ""}`} aria-label={isEnglish ? "Main navigation" : "منوی اصلی"}>
      {links[language].map(([to, label]) => <Link className={location.pathname === to ? "active" : ""} key={to} to={to}>{label}</Link>)}
      <div className="ia-nav__mobile-actions"><button className="ia-language" type="button" onClick={toggleLanguage}>{isEnglish ? "FA" : "EN"}</button><Link to="/SignIn">{copy.login}</Link><Link to="/SignUp">{copy.start} <ArrowLeft size={17} /></Link></div>
    </nav>
    <div className="ia-nav__actions"><button className="ia-language" type="button" onClick={toggleLanguage}>{isEnglish ? "FA" : "EN"}</button><Link to="/SignIn">{copy.login}</Link><Link to="/SignUp">{copy.start} <ArrowLeft size={17} /></Link></div>
    <button className="ia-nav__toggle" type="button" onClick={() => setOpen((value) => !value)} aria-label={open ? copy.close : copy.open}>{open ? <X /> : <Menu />}</button>
  </div></header>;
};

export default Navbar2;
